import { ReactNode } from 'react';
import S from './NoticeBox.module.scss';
export const NoticeBox = ({
  title,
  children
}: {
  title?: string;
  children: ReactNode;
}) => {
  return <div className={S.notice} data-sentry-component="NoticeBox" data-sentry-source-file="NoticeBox.tsx">
      {title && <strong className={S.notice_title}>{title}</strong>}
      <div className={S.notice_list}>{children}</div>
    </div>;
};